import { render } from "./PolicyDetailView.vue?vue&type=template&id=61b184be&scoped=true"
import script from "./PolicyDetailView.vue?vue&type=script&lang=js"
export * from "./PolicyDetailView.vue?vue&type=script&lang=js"

import "./PolicyDetailView.vue?vue&type=style&index=0&id=61b184be&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b184be"]])

export default __exports__